import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  page: {
    '@media print': {
      position: 'inherit !important',
      overflow: 'inherit !important',
    },
  },
}));

export const setBodyOverflow = (hidden = false, className = '') => {
  const elem = document.getElementsByTagName('body')[0];

  try {
    if (hidden) {
      elem.style['touch-action'] = 'none';
      elem.style.overflow = 'hidden';
      elem.style.position = 'fixed';
      elem.style.top = '0px';
      elem.style.bottom = '0px';
      elem.style.left = '0px';
      elem.style.right = '0px';
      elem.classList.add(className);
    } else {
      elem.style['touch-action'] = '';
      elem.style.overflow = '';
      elem.style.position = '';
      elem.style.top = '';
      elem.style.bottom = '';
      elem.style.left = '';
      elem.style.right = '';
      elem.className = '';
    }
  } catch (err) {
    console.warn(err);
  }
};

export default (props = {}) => {
  const { hidden } = props;
  const classes = useStyles();

  useEffect(() => {
    setBodyOverflow(hidden, classes.page);

    return () => {
      setBodyOverflow();
    };
  }, [hidden]);

  return {
    setBodyOverflow,
  };
};
